import React, { useState, useEffect, useRef } from "react";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import RaceTicketsTable from "./RaceTicketsTable";
import TicketsInfoTable from "./TicketsInfoTable";
import dayjs from "dayjs";
import Rights from "../../constants/Rights";

const PossiblePastPostModal = ({
  datePastPostFilter,
  setDatePastPostFilter,
  pastPostTicketsByDate,
  setPastPostTicketsByDate,
  getPastPostTicketsByDate,
  selectedTicketsVoidScore,
  setSelectedTicketsVoidScore,
  scoreTickets,
  selectAllTickets,
  setSelectAllTickets,
  voidTickets,
  callTicketVoidListFrom,
  isPastPostTicketsModalOpen,
  setIsPastPostTicketsModalOpen,
  userRightsList,
}) => {
  const [ticketInfo, setTicketInfo] = useState([]);
  const closeButtonRef = useRef();
  const [raceIdSelected, setRaceIdSelected] = useState("");

  useEffect(() => {
    if (isPastPostTicketsModalOpen) {
      const today = new Date();
      if (!dayjs(datePastPostFilter).isSame(today, "day")) {
        setDatePastPostFilter(today);
      }
    }
  }, [isPastPostTicketsModalOpen]);

  useEffect(() => {
    if (!isPastPostTicketsModalOpen) return;
    if (!datePastPostFilter) return;

    setTicketInfo([]);
    getPastPostTicketsByDate();
  }, [isPastPostTicketsModalOpen, datePastPostFilter]);

  useEffect(() => {
    if (callTicketVoidListFrom && callTicketVoidListFrom.fromHeaderPastPost) {
      getPastPostTicketsByDate();
    }
  }, [callTicketVoidListFrom]);

  useEffect(() => {
    if (pastPostTicketsByDate.length > 0) {
      //Filter the new data to obtain the information for the selected race.
      const updatedRace = pastPostTicketsByDate.filter(
        (tickets) => tickets.RaceID === parseInt(raceIdSelected),
      )[0];

      //Update the “ticketInfo” status with the new data for the selected race.
      if (
        updatedRace &&
        updatedRace.PastPostList &&
        updatedRace.PastPostList.length > 0
      ) {
        setTicketInfo(updatedRace, {
          PastPostList: updatedRace.PastPostList,
        });
      }
    }
  }, [pastPostTicketsByDate]);

  //This function is used to close the modal when the user clicks the close button
  const closeModal = () => {
    closeButtonRef.current.click();
    setSelectedTicketsVoidScore([]);
    setRaceIdSelected("");
    setSelectAllTickets(false);
    setIsPastPostTicketsModalOpen(false);
    setPastPostTicketsByDate([]);
    setDatePastPostFilter(new Date());
  };

  //This function is used when the user clicks the refresh button
  const refreshPastPost = () => {
    getPastPostTicketsByDate();
    setSelectedTicketsVoidScore([]);
  };

  return (
    <>
      <div
        className="modal fade"
        id="possiblePastPostModal"
        role="dialog"
        aria-hidden="false"
        data-keyboard="false"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header headerModals">
              <h5 className="modal-title" id="possiblePastPostModal">
                Possible Past-Post Tickets for{" "}
                {dayjs(datePastPostFilter).format("DD-MMM-YYYY")}
              </h5>
              <span
                data-dismiss="modal"
                ref={closeButtonRef}
                style={{ cursor: "inherit" }}
              ></span>
              <button type="button" className="close" onClick={closeModal}>
                &times;
              </button>
            </div>
            <div className="modal-body">
              <div style={{ display: "flex" }}>
                <div>
                  <DatePicker
                    selected={datePastPostFilter}
                    onChange={(date) => {
                      setDatePastPostFilter(date);
                    }}
                    className="form-control text-center"
                  />
                </div>
              </div>
              <hr />
              <div className="row">
                <div className="col-sm-4">
                  <RaceTicketsTable
                    pastPostTicketsByDate={pastPostTicketsByDate}
                    setTicketInfo={setTicketInfo}
                    setSelectedTicketsVoidScore={setSelectedTicketsVoidScore}
                    raceIdSelected={raceIdSelected}
                    setRaceIdSelected={setRaceIdSelected}
                  />
                </div>
                <div className="col-sm-8">
                  <TicketsInfoTable
                    ticketInfo={ticketInfo}
                    selectedTicketsVoidScore={selectedTicketsVoidScore}
                    setSelectedTicketsVoidScore={setSelectedTicketsVoidScore}
                    selectAllTickets={selectAllTickets}
                    setSelectAllTickets={setSelectAllTickets}
                    userRightsList={userRightsList}
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <div className="col-sm-6">
                <button
                  type="button"
                  className="btn btn-info"
                  onClick={() => refreshPastPost()}
                >
                  Refresh
                </button>
              </div>
              <div
                className="col-sm-6"
                style={{ textAlign: "right", paddingRight: "0px" }}
              >
                {userRightsList.find(
                  (right) => right.FormName === Rights.FRM_VOID_TICKET,
                ) && (
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={() =>
                      voidTickets("PPTSHeader", selectedTicketsVoidScore)
                    }
                  >
                    Void Selected Tickets
                  </button>
                )}
                {userRightsList.find(
                  (right) => right.FormName === Rights.FRM_SCORE_TICKETS,
                ) && (
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={() =>
                      scoreTickets("PPTSHeader", selectedTicketsVoidScore)
                    }
                  >
                    Score Selected Tickets
                  </button>
                )}
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={closeModal}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PossiblePastPostModal;
